import { FormStatusType } from '@/enums/form-status.enum'
import { DEFAULT_BONUS_PRIORITY } from '@/constants'
import { Bonus, BonusEngineState } from '../models'

/**
 * INITIAL BONUS VALUES
 */
export const initialBonus: Bonus = {
  _id: 0,
  name: '',
  description: '',
  code: '',
  type: '',
  priority: DEFAULT_BONUS_PRIORITY,
  maxBet: [],
  maxWin: [],
  trigger: {
    triggerBy: 0,
    prerequisites: {
      depositCount: '',
      condition: '',
    },
    minimumDepositAmount: [],
    paymentMethods: [],
  },
  bonusAmount: [],
  mode: '',
  rollover: 0,
  rolloverCoefficcient: 0,
  // eligibility: {
  //   id: 0,
  //   promotionalCodesAvailables: '',
  //   promotionalCodesUnavailables: '',
  //   creditCardTiersAvailables: '',
  //   creditCardTiersUnavailables: '',
  // },
  isActive: false,
  // isMakeUpRule: false,
  providers: [],
  restrictions: {
    id: 0,
    products: [],
    wagerTypes: [],
    sports: [],
    line: {
      max: 0,
      min: 0,
    },
  },
}

/**
 * SET INITIAL BONUS STATE
 */
const initialState: BonusEngineState = {
  isLoading: true,
  bonusFormMode: FormStatusType.CREATE,
  hasError: false,
  error: '',
  wasDeleted: false,
  bonuses: [],
  bonusesByBundle: [],
  currentBonus: initialBonus,
  providers: [],
  providersCategories: [],
  games: [],
  pagination: {
    total: 0,
    limit: 25,
    page: 1,
    pages: 1,
  },
  filters: {
    page: 1,
    limit: 25,
  },
  bonusNames: [],
  isLoadingProviders: false,
}

export default initialState
